module.exports = __webpack_public_path__ + "6b707c61/img/chevron-right-icon.253a4260.svg";